import React, { useRef, useState } from 'react';
import styles from './index.module.scss';
import { useScreenSlideIn } from '@/hooks/useScreenSlideIn';
import bgLeft from '@/assets/home/new-screen7-left.png';
import bgRight from '@/assets/home/new-screen7-right.png';

// 第七屏：进校项目
export default function Screen7() {
  const slideInRef = useScreenSlideIn({
    triggerSlideRatio: 0.8,
    animationClassName: styles['screen7-anim-start'],
    triggerOnce: true,
  });
  const screenRef = useRef<HTMLDivElement>(null);
  const [hoveredCardId, setHoveredCardId] = useState<number | null>(null);

  const projects = [
    {
      id: 1,
      title: '爱学助力海淀区人北实验学校“AI语文实验课”',
      descrriptionShort:
        '2025年12月7日，爱学携手海淀区人北实验学校落地了“AI语文实验课”，数字人“苏轼”身着宋代文士服饰现身课堂与师生互动。',
      description: `2025年12月7日，爱学携手海淀区人北实验学校落地了“AI语文实验课”，数字人“苏轼”身着宋代文士服饰现身课堂与师生互动。通过实时互动、交流对话，这一跨越千年的数字邂逅，让前沿大模型技术成为连接经典与现代的桥梁，也展现出了“AI+教育”的无限可能，是一次人工智能深度融入教学场景、开启智慧教育的创新实践。`,
      image: bgLeft,
    },
    {
      id: 2,
      title: '爱学自然拼读走进中关村第二小学万泉河分校',
      descrriptionShort:
        '2025年12月，爱学走进中关村第二小学万泉河分校，旗下产品爱学AI英语成为该校课后服务产品。',
      description: `2025年12月，爱学走进中关村第二小学万泉河分校，旗下产品爱学AI英语成为该校课后服务产品。`,
      image: bgRight,
    },
  ];

  return (
    <section className={styles['screen7-cover']} ref={slideInRef.ref}>
      <div className={styles['screen7-wrap']} ref={screenRef}>
        {/* 标题 */}
        <div className={styles['screen7-title-container']}>
          <h2 className={styles['screen7-title']}>进校项目</h2>
        </div>

        {/* 项目卡片 */}
        <div className={styles['screen7-projects']}>
          {projects.map((project) => (
            <div
              key={project.id}
              className={styles['screen7-project-card']}
              onMouseEnter={() => setHoveredCardId(project.id)}
              onMouseLeave={() => setHoveredCardId(null)}
            >
              <div className={styles['screen7-card-image']}>
                <img
                  className={styles['screen7-card-img']}
                  src={project.image}
                  alt={project.title}
                  loading="lazy"
                />
              </div>
              <div className={styles['screen7-card-content']}>
                <h3 className={styles['screen7-card-title']}>{project.title}</h3>
                <p
                  className={`${styles['screen7-card-description']} ${
                    hoveredCardId === project.id ? styles['screen7-card-description-hover'] : ''
                  }`}
                >
                  {hoveredCardId === project.id ? project.description : project.descrriptionShort}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
